import { render, staticRenderFns } from "./LoginLogo.vue?vue&type=template&id=4a04fdfe&"
import script from "./LoginLogo.vue?vue&type=script&lang=js&"
export * from "./LoginLogo.vue?vue&type=script&lang=js&"
import style0 from "./LoginLogo.vue?vue&type=style&index=0&id=4a04fdfe&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports